module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("b25ru"))).then(() => parcelRequire('4UTDD'));